/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon } from "../../";
export function IconTrim(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M4 6c.333 0 .651-.065.942-.183L7.02 8.295 2.2 14.04l1.149.964L8 9.46l4.65 5.543 1.15-.964-4.82-5.745 2.078-2.478a2.5 2.5 0 1 0-1.156-.956L8 7.128 6.098 4.86A2.5 2.5 0 1 0 4 6zm0-1.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm9-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M6 9c.503 0 .98-.106 1.413-.297l3.28 3.91L3.9 20.71l1.533 1.285L12 14.17l6.567 7.825L20.1 20.71l-6.794-8.097 3.281-3.91a3.5 3.5 0 1 0-1.523-1.298L12 11.058 8.936 7.406A3.5 3.5 0 1 0 6 9zm0-2a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm13.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z\'/>'
  }];
  var closestSize = findClosestGlyphAvailable(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconTrim is deprecated and will be archived soon. Use IconTrim instead.
 */
export function Experimental__IconTrim(props) {
  return /*#__PURE__*/React.createElement(IconTrim, props);
}